import React, { ReactNode } from 'react';
import { cva } from 'class-variance-authority';
import styles from './ButtonGroup.module.css';

const buttonGroupStyles = cva(styles.buttonGroup, {
  variants: {
    align: {
      start: styles.alignStart,
      center: styles.alignCenter,
      end: styles.alignEnd,
      justify: styles.alignJustify,
      split: styles.alignSplit,
      stack: styles.alignStack,
      stackFlip: styles.alignStackFlip,
    },
  },
  defaultVariants: {
    align: 'start',
  },
});

export interface ButtonGroupProps {
  /**
   * The buttons to be displayed within the group (maximum of three).
   */
  children: ReactNode;

  /**
   * Determines how the buttons are arranged.
   */
  align?:
    | 'start'
    | 'center'
    | 'end'
    | 'justify'
    | 'split'
    | 'stack'
    | 'stackFlip';

  /**
   * Test ID for the component, used for testing purposes
   */
  'data-testid'?: string;
}

export const ButtonGroup = ({
  children,
  align = 'start',
  'data-testid': dataTestId,
}: ButtonGroupProps) => {
  return (
    <div
      className={`${buttonGroupStyles({ align })}`}
      role="group"
      aria-label="Button Group"
      data-testid={dataTestId}
    >
      {React.Children.map(children, (child) => child)}
    </div>
  );
};

export default ButtonGroup;
